import React, { useState, Fragment, useContext } from "react";
import { Typography, Button, Collapse, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import DataServiceList from "../List/dataservice";
import { LangContext } from "../../Context/Langcontext";

const useStyles = makeStyles((theme) => ({
  mainText: {
    color: "#E16733",
    fontSize: "1.2rem",
    fontWeight: 700,
  },
  secondText: {
    color: "#595A5A",
    fontSize: "1rem",
    fontWeight: 200,
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  headertable: {
    height: "5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "gray",
    borderTop: "1px solid #515151",
    borderLeft: "1px solid #515151",
    borderBottom: "1px solid #515151",
  },
  bodytable: {
    borderLeft: "1px solid #515151",
    borderBottom: "1px solid #515151",
  },
  headertext: {
    color: "#faf7f1",
    fontWeight: 400,
  },
  btn: {
    margin: "1rem 0rem",
    color: "#515151",
  },
  thirdtext: {
    color: "#595A5A",
    fontSize: "1rem",
    fontWeight: 700,
  },
}));

const Description = () => {
  const classes = useStyles();
  const [show, setShow] = useState(false);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  return (
    <div>
      <Typography className={classes.mainText}>
        {lang.DescriptionService}
      </Typography>
      <Button
        variant="text"
        className={classes.btn}
        onClick={() => {
          setShow(!show);
        }}
      >{`${
        show
          ? langContext.lang.locale === "th"
            ? "ย่อ <<"
            : "Hide <<"
          : `${lang.Seemore} >>`
      }`}</Button>
      <Collapse in={show} timeout="auto" unmountOnExit>
        <Typography className={classes.secondText}>
          {lang.SubtitlesDescription}
        </Typography>
        <Grid container spacing={1} style={{ margin: "1rem 0rem" }}>
          <Grid item xs={4} className={classes.headertable}>
            <Typography className={classes.headertext}>Layers</Typography>
          </Grid>

          <Grid
            item
            xs={4}
            className={classes.headertable}
            style={{ borderRight: "1px solid #515151" }}
          >
            <Typography className={classes.headertext}>
              Endpoint Name
            </Typography>
          </Grid>
          <Grid item xs={4}></Grid>

          <Grid
            item
            xs={8}
            className={classes.bodytable}
            style={{ borderRight: "1px solid #515151" }}
          >
            <Typography className={classes.thirdtext}>
              {lang.Landbase}
            </Typography>
          </Grid>
          <Grid item xs={4}></Grid>
          {DataServiceList().landbase.map((rs, index) => {
            return (
              <Fragment key={`landbase_${rs.endpoint}`}>
                <Grid item xs={4} className={classes.bodytable}>
                  <Typography className={classes.secondText}>{`${index + 1}. ${
                    rs.title
                  }`}</Typography>
                </Grid>
                <Grid
                  item
                  xs={4}
                  className={classes.bodytable}
                  style={{ borderRight: "1px solid #515151" }}
                >
                  <Typography className={classes.secondText}>
                    {rs.endpoint}
                  </Typography>
                </Grid>
                <Grid item xs={4}></Grid>
              </Fragment>
            );
          })}
          <Grid
            item
            xs={8}
            className={classes.bodytable}
            style={{ borderRight: "1px solid #515151" }}
          >
            <Typography className={classes.thirdtext}>
              {lang.Electric}
            </Typography>
          </Grid>
          <Grid item xs={4}></Grid>
          {DataServiceList()
            .electric.filter((rs) => {
              return rs.endpoint !== "fiber-obtic";
            })
            .map((rs, index) => {
              return (
                <Fragment key={`electric_${rs.endpoint}`}>
                  <Grid item xs={4} className={classes.bodytable}>
                    <Typography className={classes.secondText}>{`${
                      index + 1
                    }. ${rs.title}`}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    className={classes.bodytable}
                    style={{ borderRight: "1px solid #515151" }}
                  >
                    <Typography className={classes.secondText}>
                      {rs.endpoint}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}></Grid>
                </Fragment>
              );
            })}
          <Grid
            item
            xs={8}
            className={classes.bodytable}
            style={{ borderRight: "1px solid #515151" }}
          >
            <Typography className={classes.thirdtext}>Layer Group</Typography>
          </Grid>
          <Grid item xs={4}></Grid>
          {DataServiceList().layergroup.map((rs, index) => {
            return (
              <Fragment key={`layergroup_${rs.endpoint}`}>
                <Grid item xs={4} className={classes.bodytable}>
                  <Typography className={classes.secondText}>{`${index + 1}. ${
                    rs.title
                  }`}</Typography>
                </Grid>
                <Grid
                  item
                  xs={4}
                  className={classes.bodytable}
                  style={{ borderRight: "1px solid #515151" }}
                >
                  <Typography className={classes.secondText}>
                    {rs.endpoint}
                  </Typography>
                </Grid>
                <Grid item xs={4}></Grid>
              </Fragment>
            );
          })}
        </Grid>
      </Collapse>
    </div>
  );
};

export default Description;
